import { Link } from "react-router-dom";
import { LOGOS, SITE_LINKS } from "@/lib/content";

export const SiteLinks = ({ keys, className = "" }) => (
  <nav className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm text-ink-soft ${className}`} data-testid="site-links">
    {keys.map((k, i) => {
      const l = SITE_LINKS[k];
      const external = l.href.startsWith("http");
      return (
        <span key={k} className="inline-flex items-center gap-3">
          {i > 0 && <span aria-hidden="true" className="text-rule">|</span>}
          {external
            ? <a href={l.href} target="_blank" rel="noopener noreferrer" className="hover:text-charcoal underline-offset-4 hover:underline"
                style={{ transition: "color .3s ease" }} data-testid={`site-link-${k}`}>{l.label}</a>
            : <Link to={l.href} className="hover:text-charcoal underline-offset-4 hover:underline"
                style={{ transition: "color .3s ease" }} data-testid={`site-link-${k}`}>{l.label}</Link>}
        </span>
      );
    })}
  </nav>
);

export const Logo = ({ variant = "gold", className = "h-[34px]", testId }) => (
  <img src={LOGOS[variant]} alt="AHU" className={`w-auto select-none ${className}`} draggable={false} data-testid={testId} />
);

export const GoldDots = () => (
  <div className="flex items-center gap-3" data-testid="gold-dots" aria-hidden="true">
    {[0, 1, 2].map((i) => (
      <span key={i} className="gold-dot h-2.5 w-2.5 rounded-full bg-gold" style={{ animationDelay: `${i * 0.3}s` }} />
    ))}
  </div>
);

export const Footer = ({ dark = true }) => (
  <footer className={`${dark ? "bg-charcoal-deep text-alabaster/80" : "text-ink-soft"} px-6 py-6 text-center text-sm`} data-testid="app-footer">
    <span data-testid="footer-copyright">© {new Date().getFullYear()} Te Ahu Solutions Ltd. All rights reserved.</span>{" "}
    <span>AHU is a{" "}
      <a href="https://teahusolutions.com" target="_blank" rel="noopener noreferrer" className="underline underline-offset-4" data-testid="footer-teahu-link">Te Ahu Solutions</a>{" "}
      product.</span>
  </footer>
);

export const Dots = ({ total, current }) => (
  <div className="flex items-center gap-2" data-testid="progress-dots">
    {Array.from({ length: total }).map((_, i) => (
      <span key={i} className={`h-2 rounded-full ${i === current ? "w-6 bg-sage" : "w-2 bg-rule"}`} style={{ transition: "width .5s ease, background-color .5s ease" }} />
    ))}
  </div>
);

export const PageHead = ({ eyebrow, title, sub }) => (
  <div className="mb-8 fade-in">
    {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
    <h1 className="text-3xl sm:text-4xl lg:text-[44px] leading-tight">{title}</h1>
    {sub && <p className="mt-3 text-base text-ink-soft max-w-xl">{sub}</p>}
  </div>
);
